import React from 'react'
import ServiceLayout from 'components/ServiceLayout'

const BLOCKS = [
  {
    title: 'SEO Técnico',
    desc: 'A base que garante que seu site seja encontrado e bem interpretado pelos mecanismos de busca.',
    items: [
      'Auditoria técnica completa do site',
      'Otimização de velocidade e Core Web Vitals',
      'Estruturação de URLs, sitemap e robots.txt',
      'Correção de erros de indexação e rastreamento',
    ],
  },
  {
    title: 'Conteúdo & Palavras-chave',
    desc: 'Conteúdo estratégico que atrai tráfego qualificado e ranqueia no longo prazo.',
    items: [
      'Pesquisa e estratégia de palavras-chave',
      'Otimização de conteúdo para SEO',
      'Planejamento de conteúdo orgânico',
      'Otimização de páginas e categorias',
    ],
  },
  {
    title: 'Busca em Redes Sociais',
    desc: 'Otimização de busca dentro das próprias redes sociais, onde seu público também pesquisa.',
    items: [
      'Otimização de bio, legendas e hashtags',
      'Estratégia de palavras-chave para redes sociais',
      'Alinhamento entre SEO do site e presença social',
      'Monitoramento de resultados orgânicos',
    ],
  },
]

const STEPS = [
  { title: 'Auditoria', desc: 'Analisamos a saúde técnica do site e a presença orgânica atual.' },
  { title: 'Estratégia', desc: 'Definimos palavras-chave, prioridades técnicas e plano de conteúdo.' },
  { title: 'Otimização', desc: 'Implementamos ajustes técnicos, de conteúdo e de redes sociais.' },
  { title: 'Monitoramento', desc: 'Acompanhamos rankings e resultados, ajustando a estratégia continuamente.' },
]

function ServiceSEO() {
  return (
    <ServiceLayout
      pageTitle='Agência Dorac - SEO Estratégico'
      eyebrow='SEO Estratégico'
      title='Presença orgânica que faz seu negócio ser encontrado'
      subtitle='Trabalhamos SEO de forma completa: da estrutura técnica do site ao conteúdo que atrai e ranqueia, incluindo a otimização de busca dentro das próprias redes sociais.'
      intro='Estar bem posicionado no Google não é sorte, é consequência de um trabalho técnico e estratégico contínuo. Da auditoria à otimização de conteúdo, cada ação de SEO da Dorac é pensada para sustentar crescimento orgânico de longo prazo, no site e nas redes sociais.'
      blocks={BLOCKS}
      steps={STEPS}
      ctaText='Quero aparecer no Google'
    />
  )
}

export default ServiceSEO
